import React from 'react'
import { Publication } from 'src/core/models'
import { getDateFormattedSmall } from 'src/core/helpers'
import { CustomText, PublicationUrlLanguagesColumn } from 'src/components'

const PublicationMovileViewColumn: React.FC<{ publication: Publication}> = ({ publication }) => {

  return <>
    <CustomText label={publication.name} strong />
    <div className='flex-space-between'>
      <CustomText label={getDateFormattedSmall(publication.created)} />
      <PublicationUrlLanguagesColumn urls={publication.urls} />
    </div>
  </>
}

export default PublicationMovileViewColumn
